const createCustomerForm = document.getElementById("create_customer");
if (createCustomerForm) {
  createCustomerForm.addEventListener("change", async (event) => {
    const formData = new FormData(createCustomerForm);
    for (const [key, value] of formData.entries()) {
      if (customerFormKeys[key]) {
        if (value) {
          let registrationTags = document.querySelectorAll(".register-types input");
          sessionStorage.setItem(customerFormKeys[key], value);
        }
      }
    }
  });

  const submitButton = createCustomerForm.querySelector("button[type='submit']");
  const errorMessages = createCustomerForm.querySelector(".error-messages");

  const customerTypes = document.querySelectorAll(".register-types input");
  const customerTypeSelected = Array.from(customerTypes).find((type) => type.checked);

  customerTypes.forEach((type) => {
    type?.addEventListener("change", () => {
      handleCustomerTypeChange(type);
    });
  });

  handleCustomerTypeChange(customerTypeSelected);

  function handleCustomerTypeChange(type) {
    if (type && type.checked) {
      submitButton.removeAttribute("disabled");
      if (errorMessages && registrationFormStrings.select_customer_type) {
        errorMessages.classList.remove("banner", "banner--error");
        errorMessages.innerHTML = "";
      }
    } else {
      submitButton.setAttribute("disabled", "disabled");
      if (errorMessages && registrationFormStrings.select_customer_type) {
        errorMessages.classList.add("banner", "banner--error");
        errorMessages.innerHTML = `<p>${registrationFormStrings.select_customer_type}</p>`;
      }
    }
  }
}

const customerFormKeys = {
  "customer[date_of_birth]": "reg_dob",
  "customer[company]": "reg_company",
  "customer[company_id]": "reg_company_id",
  "customer[vat_number]": "reg_vat_number",
  "customer[phone]": "reg_phone",
  "customer[tags]": "reg_tags",
};
